<div class="zero-desktop-header">
  @if (activeTab !== 'main') {
    <button class="back-btn" (click)="subpageBackClicked.emit()" aria-label="Zurück">
      <img [src]="backIconSrc()" alt="" width="44" height="44" />
    </button>
  }

  <div class="stock-identity">
    @if (stockLogo) {
      <img [src]="stockLogo" alt="" width="28" height="28" class="stock-logo" />
    }
    <span class="stock-name">{{ stockName }}</span>
  </div>

  <app-v3-tab-navigation
    class="tab-nav"
    [activeTab]="activeTab"
    [tabs]="tabs"
    (tabChange)="tabChange.emit($event)"
  ></app-v3-tab-navigation>

  <div class="price-block">
    @if (price !== null && price !== undefined) {
      <div
        class="price-values"
        [class.positive]="prevPrice !== null && prevPrice !== undefined && price > prevPrice"
        [class.negative]="prevPrice !== null && prevPrice !== undefined && price < prevPrice"
      >
        <p class="price">{{ price | priceScale }}</p>
        @if (prevPrice !== null && prevPrice !== undefined) {
          <p class="change">{{ price | percentageChange: prevPrice }}</p>
        }
      </div>
    }
  </div>
</div>
